<template>
  <HoverSplit :class="{'moved-up': component.moveUp, 'view': tapStore.view, 'delete': del}" class="component" :data-type="'component'"
              :view="tapStore.view" @click="clickEvent(component.uniqueId)"
              @add="addComponentToBlock(block.id, $event ? component.orderIndex - 1 : component.orderIndex)" >
    <ActionHeader class="pl-1 pr-1 mb-2" drag-class="drag" :show-drag="hasMoreThanOneChild"
                  :show-up="component.orderIndex > 1 || block.orderIndex > 1" :change="component.changed && tapStore?.currentTap?.status.id == 3"
                  :show-down="component.orderIndex < block.blockItems.length || block.orderIndex < blocks.length"
                  :confirm-remove="component.type === 'tariffs'" :center-undo="component.type === 'tariffs'"
                  :undo-timeout="component.type === 'tariffs' ? 5000 : undefined"
                  :remove-title="$t('Удалить блок «Тарифы»?')"
                  :remove-description="$t('Блок «Тарифы» будет удалён со страницы. Вернуть его можно в течение 5 секунд.')"
                  @pendingRemove="pendingDelete"
                  @remove="remove" @up="moveUp" @down="moveDown" v-if="!tapStore.view"/>
    <TypeSelector :type="component.type"
                  :settings="component.data"
                  :componentFullData="component"
                  :blockId="block.id"
                  :class="{'pointer-events-none': del}"
                  :componentUniqueId="component.uniqueId"
                  @element-click="handleIdReceive(component.uniqueId, $event)"
                  :view="tapStore.view"/>
  </HoverSplit>
</template>


<script setup lang="ts">
import HoverSplit from '@/components/tap/HoverSplit.vue'
import ActionHeader from '@/components/tap/ActionHeader.vue'
import TypeSelector from '@/components/types/TypeSelector.vue'
import { useComponents } from '@/composables/useComponents'
import { useBlocks } from '@/composables/useBlocks'
import {computed, ref} from 'vue'
import {useDialogStore} from "@/stores/dialogStore";
import {useTapStore} from '@/stores/tapStore';
import ListBlockTypes from "@/components/dialogs/ListBlockTypes.vue";
import {useRoute} from "vue-router";


const props = defineProps<{ component: any, block: any }>()
const { removeComponent, moveComponent } = useComponents()
const { blocks } = useBlocks()
const dialogStore = useDialogStore()
const tapStore = useTapStore();
const del = ref(false)

const hasMoreThanOneChild = computed(() => {
  let count = 0;

  for (const item of blocks.value) {
    count += item.blockItems.length;
    if (count > 1) return true
  }
  return false;
})

const route = useRoute()
const remove = () => removeComponent(props.block.uniqueId, props.component.uniqueId)
const moveUp = () => moveComponent(props.block.uniqueId, props.component.uniqueId, true)
const moveDown = () => moveComponent(props.block.uniqueId, props.component.uniqueId, false)
const addComponentToBlock = (blockId, order) => {
  dialogStore.open(ListBlockTypes, {blockId: blockId, order: order})
}
const clickEvent = (uniqueId) => {
  if (!enableAnalytics) return
  tapStore.analytic(uniqueId)
}

const enableAnalytics = computed(() => {
  return tapStore.view && !/^\/profile\/[^\/]+\/(edit|view)\/?$/.test(route.path)
})

const pendingDelete = (val) => {
  del.value = val
}

const handleIdReceive = (uniqueId: string, id: string | number) => {
  if (!enableAnalytics) return
  tapStore.analytic(uniqueId, id)
};
</script>

<style scoped lang="sass">
.component
  padding: 8px
  border-radius: 8px
  border: 1px dashed #DEE2E6
  background: #fff
  position: relative
  cursor: pointer
  &.delete::before
    content: ''
    position: absolute
    inset: 0
    pointer-events: none
    opacity: 0.5
    background: #fff
    z-index: 2
    user-select: none
  &.delete:hover
    border: 1px dashed #DEE2E6
  &.view
    padding: 0
    border: none
    cursor: default
    &:not(:last-child):not(.ghost)
      margin-bottom: 24px
  &:hover
    border-color: #0D87EF
  &:not(:last-child):not(.ghost)
    margin-bottom: 12px
</style>
